<template>
  <div>

    <div class="login_div">
      <el-row class="moibleDownload">
        <span class="right" @click="doubleCode">
          <img src="static/image/phone.png" alt="恒安e行" />
        </span>
      </el-row>
      <el-row type="flex" class="row-bg">

        <el-col :span="24">

          <div class="logo"><img src="static/image/hengan_logo@3x.png" /></div>

        </el-col>

      </el-row>

      <form :action="url" method="post">

        <div class="login_input">

          <el-row style="border-bottom: 1px solid #dcdfe6;">

            <div class="login-tubiao">

              <img src="static/image/username_icon_login.png" />

            </div>

            <el-col :span="20">

              <input class="input" type="text" style="border:none" v-model="form.userId" name="username"
                @keydown="keyLogin($event)" placeholder="请输入手机号/邮箱/用户名">

            </el-col>

          </el-row>

        </div>

        <div class="login_input">

          <el-row style="border-bottom: 1px solid #dcdfe6;">

            <div class="login-tubiao">

              <img src="static/image/password_icon_login.png" />

            </div>

            <el-col :span="20">

              <input class="input" type="password" style="border:none" v-model="form.passwd" name="password"
                @keydown="keyLogin($event)" placeholder="请输入密码">

            </el-col>

          </el-row>

        </div>

        <div class="login_input chooose">
          <div>
            <el-checkbox v-model="checked"></el-checkbox>
            <span class="read_policy">阅读并接受<span class="policy" @click="readPolicy()">隐私政策</span></span>
          </div>
          <div>
            <span @click="forgetPassword" style="float:right;font-size:14px;cursor: pointer;"> 忘记密码</span>
          </div>

        </div>

        <!-- <div class="login_input">

                            <el-row>

                              <el-col :span="3" class="label">

                               rsid

                              </el-col>

                              <el-col :span="20">

                                 <el-input class="input" type="text" name="rsid"></el-input>

                              </el-col>

                            </el-row>

                          </div> -->

        <input type="hidden" name="TYPE" value="CUSTOM2" /><br />

        <div class="btn_div">

          <!-- <input class="el" type="submit" /> -->

          <!-- <el-button @click="login">登录</el-button> -->

          <el-button class="el" @click="loginAction">登录</el-button>

        </div>
      </form>
    </div>
    <el-dialog title="恒安e行" :visible.sync="doubleShow" width="30%" center>
      <div style="text-align:center;">
        <div>安卓</div>
        <img :src="downloadQrCodeUrl" style="width:70%">
        <hr>
        <div>IOS</div>
        <img src="../assets/appDownload/ios.png" style="width:70%" alt="">
      </div>
    </el-dialog>
   <p class="desc">本网站已支持IPV6 &nbsp;&nbsp;&nbsp;&nbsp;
    <a href="https://beian.miit.gov.cn/"  target="_blank"
       style="text-decoration: none">津ICP备05010558号-5A</a>
    </p>
  </div>
</template>

<script>
  import sessionstorage from '@/components/cache'

  import api from '@/modules/api.js'

  export default {

    data() {

      return {
        checked: false,

        SSOROOTPATH: '',

        homePage: '',

        redirectPath: '',

        url: '',

        errorMsg: '',

        form: {

          userId: '',

          passwd: '',

          channel: 'SALES-PAD'

        },

        state: '',

        canExam: '',

        valid: null,

        req: {

          businessNo: ''

        },
        doubleShow: false

      }

    },
    computed: {
      downloadQrCodeUrl() {
        const timestamp = Math.floor(Date.now() / 600000);
        return `https://www.ihasl.com/pages/downloadapp/app-download.png?t=${timestamp}`;
      }
    },



    methods: {

      forgetPassword() {

        window.location.href = 'https://sso.ihasl.com/modules/sso-changePasswd/load.shtml'

      },

      keyLogin(event) {

        let keyCode = event.keyCode

        if (keyCode === 108 || keyCode === 13) {

          this.loginAction()

        }

      },

      trim(str) { // 清空空格

        return str.replace(/(^\s*)|(\s*$)/g, '')

      },

      loginAction() {

        sessionstorage.session_set('sidebar_active', 'message')

        console.log(this.trim(this.form.userId))

        if (!this.trim(this.form.userId)) {

          this.$message({

            type: 'info',

            message: '用户id不能为空'

          })

          return

        }

        if (!this.trim(this.form.passwd)) {

          this.$message({

            type: 'info',

            message: '密码不能为空'

          })

          return

        }
        if(!this.checked) {
          this.$message({

          type: 'info',

          message: '请勾选隐私政策'

          })

          return
        }

        this.homePage = window.location.href.split('/')[0] + '//' + window.location.href.split('/')[1] + window.location.href.split('/')[2]

        if (this.redirectPath === '' || this.redirectPath === null || this.redirectPath === undefined) {

          this.redirectPath = this.homePage + this.$address + 'home/message'

        }

        var actionUrl = 'https://sso.ihasl.com/login?loginUrl=' + encodeURIComponent(this.homePage + this.$address) + '&service=' + encodeURIComponent(this.$loginBack + encodeURIComponent(this.redirectPath))

        sessionstorage.session_set('username', this.form.userId)

        var form = document.createElement('form')

        form.method = 'post'

        form.action = actionUrl



        var newElement = document.createElement('input')

        newElement.setAttribute('name', 'username')

        newElement.setAttribute('type', 'hidden')

        newElement.setAttribute('value', this.form.userId)

        form.appendChild(newElement)



        var newElement2 = document.createElement('input')

        newElement2.setAttribute('name', 'password')

        newElement2.setAttribute('type', 'hidden')

        newElement2.setAttribute('value', this.form.passwd)

        form.appendChild(newElement2)



        var newElement3 = document.createElement('input')

        newElement3.setAttribute('name', 'rsid')

        newElement3.setAttribute('type', 'hidden')

        newElement3.setAttribute('value', '')

        form.appendChild(newElement3)



        var newElement4 = document.createElement('input')

        newElement4.setAttribute('name', 'TYPE')

        newElement4.setAttribute('type', 'hidden')

        newElement4.setAttribute('value', 'CUSTOM2')

        form.appendChild(newElement4)



        document.body.appendChild(form)

        form.submit()

      },

      getQueryString(name) {

        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')

        var r = window.location.search.substr(1).match(reg)

        if (r != null) {

          return unescape(r[2])

        }

        return null

      },

      setCookie(name, value, expiredays) {

        var exdate = new Date()

        exdate.setDate(exdate.getDate() + expiredays)

        document.cookie = name + '=' + escape(value) +

          ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())

      },

      delCookie(name) {

        var exp = new Date()

        exp.setTime(exp.getTime() - 1)

        var cval = this.getCookie(name)

        if (cval != null) {

          document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString()

        }

      },

      getCookie(name) {

        var arr = new RegExp('(^| )' + name + '=([^;]*)(;|$)')

        var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')

        if (arr = document.cookie.match(reg)) {

          return unescape(arr[2])

        } else {

          return null

        }

      },

      funcUrlDel(name) {

        var loca = window.location

        var baseUrl = loca.origin + loca.pathname + '?'

        var query = loca.search.substr(1)

        if (query.indexOf(name) > -1) {

          var obj = {}

          var arr = query.split('&')

          for (var i = 0; i < arr.length; i++) {

            arr[i] = arr[i].split('=')

            obj[arr[i][0]] = arr[i][1]

          };

          delete obj[name]

          var url = baseUrl + JSON.stringify(obj).replace(/[\\"\\{\\}]/g, '').replace(/\\:/g, '=').replace(/\\,/g, '&')

          return url

        };

      },
      doubleCode() {
        this.doubleShow = true
      },
      readPolicy(){
        var homePage = "static/信息授权及隐私政策.html"
        window.open(homePage, '_blank');

      }

    },

    mounted() {

      // 1.删除cookie中jtl

      this.delCookie('jtl')



      // 2.支持指定目标页登录后跳转

      this.redirectPath = this.$route.query.redirectPath

      this.errorMsg = this.$route.query.errorMsg

      // 3.弹出错误信息

      if (this.errorMsg === null || this.errorMsg === '' || this.errorMsg === undefined) {

        this.errorMsg = this.getQueryString('error')

      }

    },

    watch: {

      errorMsg: {

        handler: function (newVal, oldVal) {

          if (newVal !== undefined && newVal !== null) {

            alert(decodeURI(newVal))

            // 4.删除当前url中jtl（不知道为什么会出现，当401的时候返回时，会自动加到当前url中）

            var jtlUrl = this.getQueryString('jtl')

            if (jtlUrl) {

              window.location.replace(this.funcUrlDel('jtl'))

            }

          }

        }

      }

    }

  }
</script>

<style lang="scss" scoped>
  .moibleDownload {
    cursor: pointer;
    position: absolute;
    font-weight: bold;
    font-size: 20px;
    color: #194793;
    right: 30px;
    top: 20px;

    .right {
      display: inline-block;
      width: 45px;
      height: 35px;
      // margin-left: 22px;
      text-align: center;

      &:first-child {
        width: 120px;
        // margin-right: 10px;

        &:before {
          position: absolute;
          color: #194793;
          content: "恒安e行";
          top: 0px;
          left: 28px;
          font-size: 14px;
        }

        &:after {
          content: "";
          position: absolute;
          top: 24px;
          left: 65px;
          // background-color: #194793;
          width: 2px;
          height: 22px;
        }
      }

      &:nth-child(2) {
        width: 30px;
        margin-right: -20px;

        &:before {
          position: absolute;
          color: #194793;
          content: "手机";
          top: 0px;
          left: 108px;
          font-size: 14px;
        }

      }

      // &:last-child {
      //   width: 30px;
      //   position: relative;
      //   margin-left: 24px;

      //   &:after {
      //     content: "";
      //     position: absolute;
      //     top: 22px;
      //     left: -24px;
      //     background-color: #194793;
      //     width: 2px;
      //     height: 22px;
      //   }

      //   &:before {
      //     position: absolute;
      //     color: #194793;
      //     content: "pad";
      //     top: -4px;
      //     left: 0px;
      //     font-size: 13px;
      //   }

      // }

      img {
        width: 30%;
        margin-top: 20px;
      }
    }
  }

  .container {
    margin: 0 auto;

    width: 100%;

    height: 600px;

  }

  .label {}

  .title {
    margin-bottom: 40px;

  }

  .input {
    padding-left: 0px;

    border: none !important;

    width: 100%;

    outline: none;

  }

  .btn_div {
    width: 90%;

    margin: 0 auto;

  }

  .check_btn {
    background: #ebebeb;

    border-radius: 10px;

    width: 100%;

    margin: 0 auto;

  }

  .login_div {
    width: 40%;

    margin: 80px auto;

    height: 380px;

  }

  .login_input {
    line-height: 50px;
  }

  .logo {
    text-align: center;
  }

  .login-tubiao {
    display: inline-block;

    width: 20px;

    height: 20px;

    float: left;

    margin-right: 5%;
  }

  .login-tubiao img {
    width: 100%;

    height: 100%;

    vertical-align: middle;
  }

  form {
    margin-top: 40px;
  }

  .el {
    -webkit-appearance: none;

    background-color: #194793;

    background-image: none;

    border-radius: 10px;

    color: #fff;

    border: none;

    -webkit-box-sizing: border-box;

    box-sizing: border-box;

    display: inline-block;

    font-size: inherit;

    height: 40px;

    line-height: 40px;

    outline: 0;

    padding: 0 15px;

    -webkit-transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);

    width: 100%;

    margin-top: 20px;
  }
  .desc {
    width: 100%;
    position: fixed;
    z-index: 302;
    bottom: 0;
    left: 0;
    height: 39px;
    padding-top: 1px;
    overflow: hidden;
    zoom: 1;
    margin: 0;
    line-height: 39px;
    background: #fff;
    font-size:12px;
    color: #bbb;
    text-align: center;
  }
  .chooose{
    display: flex;
    justify-content: space-between;
  }
  .read_policy{
    margin-left: 5px;
  }
  .policy{
    color: #32b2e5;
    text-decoration:underline;
    cursor:pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/logintest.vue